export default __webpack_public_path__ + "static/media/defaultLog.56c11d7a.svg";